<template lang="pug">
  #InvitationIndex.container-width
    .normalInvitation(v-if="invitation && invitation.invite_url_type === 'normal' && !showReservationSuccess")
      h4.mt-5.text-center {{ invitation.invite_title }}
      img.img-fluid.w-100.rounded(:src="invitation.invite_picture_url")
      .text-center.mt-2(v-html='invitation.invite_content')
      img.w-100(:src="invitation.invite_picture2_url")
      .text-center.mt-2(v-html='invitation.invite_content2')

    .reserveInvitation(v-if="invitation && invitation.invite_url_type === 'reservation' && !showReservationSuccess")
      h4.mt-5.text-center {{ invitation.invite_title }}
      img.img-fluid.w-100.rounded(:src="invitation.invite_picture_url")
      .text-center.mt-2(v-html='invitation.invite_content')
      img.w-100(:src="invitation.invite_picture2_url")
      .text-center.mt-2(v-html='invitation.invite_content2')
      h4.mt-5.text-center 預約服務
      .p-3.h-100.overflow-hidden
        .content
          ValidationObserver(
            ref="form"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValName"
              )
                label.mb-1(
                  for="name"
                )
                  span.text-gray 顧客姓名
                b-form-input(
                  id="name",
                  type="text",
                  required,
                  trim,
                  :state="validState('name')",
                  v-model="form.name",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入顧客姓名",
                  style="border-radius: 20px;background-color: #eee;"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 此欄不可為空
            b-form-group
              ValidationProvider(
                rules="required|mobile",
                ref="inputValMobile"
              )
                label.mb-1(
                  for="mobile"
                )
                  span.text-gray 顧客手機
                b-form-input(
                  id="mobile",
                  type="tel",
                  required,
                  trim,
                  :state="validState('mobile')",
                  v-model="form.mobile",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入顧客手機",
                  style="border-radius: 20px;background-color: #eee;"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 此欄不可為空
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValService",
                v-slot="{ errors }"
              )
                label.mb-1(
                  for="service"
                )
                  span.text-gray 預約服務
                b-form-select(
                  id="service",
                  required,
                  v-model="form.service",
                  :state="validState('service')",
                  aria-describedby="input-live-help input-name-live-feedback",
                  disabled=true,
                  placeholder="請選擇預約服務",
                  style="border-radius: 20px;background-color: #eee;",
                  @change="changeReservationTypeHandler()"
                )
                  template(
                    v-slot:first
                  )
                    b-form-select-option(
                      :value="null",
                      disabled
                    ) 請選擇預約服務
                  b-form-select-option(
                    v-for="(service,index) in reservationsTypeList",
                    :key="service.id",
                    :value="service.code"
                  ) {{ service.name }}
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 此欄不可為空
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValService",
                v-slot="{ errors }"
              )
                label.mb-1(
                  for="store"
                )
                  span.text-gray 預約櫃點
                b-form-select(
                  id="store",
                  required,
                  v-model="form.store",
                  :state="validState('store')",
                  aria-describedby="input-live-help input-name-live-feedback",
                  disabled=true,
                  placeholder="請選擇預約櫃點",
                  style="border-radius: 20px;background-color: #eee;",
                )
                  template(
                    v-slot:first
                  )
                    b-form-select-option(
                      :value="null",
                      disabled
                    ) 請選擇預約櫃點
                  b-form-select-option(
                    v-for="(store,index) in stores",
                    :key="store.id",
                    :value="store.title"
                  ) {{ store.title }}
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 此欄不可為空
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValDateId"
              )
                label.mb-1(
                  for="dateId"
                )
                  span.text-gray 預約日期
                multiselect(
                  v-model="form.dateId",
                  tag-placeholder="輸入搜尋預約日期",
                  placeholder="請選擇預約日期",
                  selectedLabel="已選擇",
                  selectLabel="點擊新增預約日期",
                  deselectLabel="選擇移除預約日期",
                  label="RegisterDate",
                  track-by="RegisterDate",
                  :custom-label="nameWithTimeId",
                  :options="reservationTimeList.RegisterDate ? reservationTimeList.RegisterDate : reservationTimeList",
                  :allow-empty="false",
                  noOptions="無預約日期",
                  style="border-radius: 20px;background-color: #eee;"
                  @select="selectDatelHandler",
                )
                  template(slot="singleLabel", slot-scope="props")
                    span.option__desc
                      span.option__title {{ props.option.RegisterDate }}
                  template(slot="option", slot-scope="props")
                    .option__desc
                      span.option__title {{ props.option.RegisterDate }}
                  template(slot="noOptions")
                    strong 無預約日期
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValTimeId"
              )
                label.mb-1(
                  for="timeId"
                )
                  span.text-gray 預約時段
                multiselect(
                  v-model="form.timeId",
                  tag-placeholder="輸入搜尋預約時段",
                  placeholder="請選擇預約時段",
                  selectedLabel="已選擇",
                  selectLabel="點擊新增預約時段",
                  deselectLabel="選擇移除預約時段",
                  label="RegisterDate",
                  track-by="RegisterDate",
                  :custom-label="nameWithTimeId",
                  :options="timeList",
                  :allow-empty="false",
                  noOptions="無預約時段",
                  style="border-radius: 20px;background-color: #eee;",
                )
                  template(slot="singleLabel", slot-scope="props, search")
                    span.option__desc
                      span.option__title {{ props.option }}
                  template(slot="option", slot-scope="props")
                    .option__desc
                      span.option__title {{ props.option }}
                  template(slot="noOptions")
                    strong 無預約時段
      .px-4
        .row.no-gutters
          .col-6.pr-2
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="closeModel()",
              style="important;border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 取消
          .col-6.pl-2
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="submitHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 確認
    .showReservationSuccess.mt-5(v-if='showReservationSuccess')
      .container-width.p-3
        h1.bind_title
          span 預約成功 ！

        .mb-4.ac_advisor.a_advisor-new.border-black.custom-shadow
          .align-items-center.justify-content-center.w-100
            h4 {{ form.service }}
            p.mb-1.w-100 預約時間: {{ form.dateId.RegisterDate }} {{ form.timeId }}
            p.mb-1.w-100 預約門市: {{ reservationStore }}
            p.mb-1.w-100 專屬顧問: {{ reservationPersonnel }}

          .ac_advisor_icon
            i.icon-icon_newBA

        .btn_wrap
          button.btn-custom.btn-b(@click.stop.prevent="backToLine()")
            span.btn_text 回官方帳號
</template>

<script>
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import $ from 'jquery';

const moment = require('moment');
const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

export default {
  name: 'InvitationIndex',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      id: null,
      form: {
        name: null,
        mobile: null,
        service: null,
        dateId: null,
        timeId: null
      },
      timeList: [],
      showReservationSuccess: false,
      reservationStore: '',
      reservationPersonnel: '',
      stores: []
    };
  },
  created() {
    const vm = this;
    vm.id = vm.$route.params.id;

    if (vm.id !== undefined && vm.id !== null) {
      window.sessionStorage.setItem('invite_id', vm.id);
    }
    const data = {
      id: window.sessionStorage.getItem('invite_id')
    }

    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('member_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('member_invitation/getInvitationHandler', data)
      .then(() => {
        vm.$store.dispatch('member_reservation/getReservationTypeListHandler')
          .then(() => {
            const campaignKey = _.findKey(vm.reservationsTypeList, (val) => val.id === vm.invitation.invite_campaign_id);
            vm.stores = [vm.store];

              vm.form = {
              name: null,
              service: vm.reservationsTypeList[campaignKey].code,
              mobile: null,
              timeId: null,
              store: vm.store.title
            };
            vm.$store.dispatch('member_reservation/getReservationTimeListHandler', {
              campaign_code: vm.reservationsTypeList[campaignKey].code,
            })
              .then(() => {
              })
              .catch(() => {
                vm.form.timeId = null;
                vm.$store.commit('member_reservation/resetReservationTimeList');
              });
          });
      })
      .catch(() => {
        vm.form.timeId = null;
        vm.$store.commit('member_reservation/resetReservationTimeList');
      });
  },
  methods: {
    nameWithTimeId({ RegisterDate, RegisterSection }) {
      return `預約日期：${RegisterDate}, 預約時段：${RegisterSection}`;
    },
    moment() {
      return moment();
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      const  vm = this;
      this.$emit('closeModelHandler');
      vm.form.name = '';
      vm.form.phone = '';
      vm.form.dateId = '';
      vm.form.timeId = '';
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      // 其餘統一判斷
      if (vm.form[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.form[key]);
        }
        return this.form[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.form.name === null) {
          vm.form.name = '';
        }
        if (vm.form.mobile === null) {
          vm.form.mobile = '';
        }
        if (vm.form.service === null) {
          vm.form.service = '';
        }
        if (vm.form.timeId === null) {
          vm.form.timeId = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        vm.$swal.fire({
          title: '表單送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        const sendData = {
          campaign_code: vm.form.service,
          register_date: vm.form.dateId.RegisterDate,
          register_section: vm.form.timeId,
          register_area: vm.form.dateId.RegisterArea,
          register_name: vm.form.name,
          register_phone: vm.form.mobile
        };

        vm.$store.dispatch('member_reservation/storeLorealReservationHandler', sendData)
          .then((res) => {
            vm.reservationStore = res.reserve_store_name;
            vm.reservationPersonnel = res.reserve_personnel_name;
            vm.$swal.close();
            vm.showReservationSuccess = true;
          });
      }
    },
    changeReservationTypeHandler() {
      const vm = this;
      if (!vm.form.service || !vm.user || (!vm.user.member_uuid && !vm.user.member_line_uuid)) return;
      vm.$swal.fire({
        title: '取得可預約時間中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      vm.$store.dispatch('member_reservation/getReservationTimeListHandler', {
        member_uuid: vm.user.member_uuid || vm.user.member_line_uuid,
        campaign_code: vm.form.service
      })
        .then(() => {
          vm.$swal.close();
        })
        .catch(() => {
          vm.form.timeId = null;
          vm.$store.commit('member_reservation/resetReservationTimeList');
        });
    },
    selectDatelHandler() {
      const vm = this;

      setTimeout(() => {

        vm.timeList = vm.form.dateId.RegisterSectionList;
      }, 50);
      // vm.timeList = vm.form.dateId.RegisterSectionList;
    },
    backToLine() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    },
  },
  computed: {
    ...mapState({
      invitation: (state) => state.member_invitation.invitation,
      reservationsTypeList: (state) => state.member_reservation.reservationsTypeList,
      reservationTimeList: (state) => state.member_reservation.reservationTimeList,
      store: (state) => state.member_reservation.store,
    })
  }
};
</script>

<style scoped>
  .top {
    background-color: #000 !important;
    width: 100%;
    border-radius: 0 0 1rem 1rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 12rem;
  }

  .border-black {
    border: 0.2rem solid #000;
  }

  .shadow-btn {
    -webkit-box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
  }

  .btn {
    border-radius: 9487px;
    font-size: 1rem;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    -webkit-box-shadow: 0.13rem 0.13rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.13rem 0.13rem 0 rgb(0 0 0 / 20%);
    background-color: $remind !important;
    color: #000 !important;
    border: 0.2rem solid #000;
    cursor: pointer;
  }

  .btn-b {
    width: 100%;
    padding: 0.5rem 0;
  }

  .bind_icon_wrap {
    width: 10rem;
    height: 10rem;
    background-color: #fff;
    border-radius: 50%;
    margin: 1rem auto 1.8rem;
    position: relative;
  }

  .bind_icon {
    width: 7rem;
    height: 0;
    padding-bottom: 7rem;
    background-position: center;
    background-size: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .bind_icon-fail {
    background-image: url(../../../assets/images/icon/bind-fail.png);
  }

  .bind_icon-success {
    background-image: url(../../../assets/images/icon/bind-success.png);
  }

  .bind_title {
    font-size: 1.6rem;
    font-weight: 800;
    text-align: center;
    margin-bottom: 1.8rem;
  }

  .bind_text {
    font-size: 0.9rem;
    line-height: 1.5;
    font-weight: 500;
    padding: 0 1rem;
    margin-bottom: 1.8rem;
  }

  .btn_wrap {
    margin-bottom: 2.3rem;
  }

  .ac_advisor {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 0.8rem;
    padding: 1.2rem;
    position: relative;
  }

  .ac_advisor-old {
    margin-bottom: 3.2rem;
    position: relative;
    background-color: #ddd;
  }

  .ac_advisor-old::after {
    display: block;
    content: "";
    position: absolute;
    width: 3rem;
    height: 4.2rem;
    background-image: url(../../../assets/images/icon/advisor-change-arrow-1.png);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    left: 50%;
    bottom: 0;
    -webkit-transform: translate(-50%, 90%);
    transform: translate(-50%, 90%);
    z-index: 1;
  }

  .ac_advisor-new {
    background-color: #fff;
  }

  .border-black {
    border: 0.2rem solid #000;
  }

  .custom-shadow {
    box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
  }

  @font-face {
    font-family: "icon";
    src: url("../../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .ac_advisor_icon {
    position: absolute;
    font-size: 3rem;
    color: #000;
    top: -1.5rem;
    right: -1.2rem;
  }

  .icon-icon_newBA:before {
    content: "\e90a";
  }

  .btn-custom {
    background-color: $remind !important;
    color: #000 !important;
    border-radius: 9487px;
    font-size: 1rem;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    -webkit-box-shadow: 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.2);
    border: 0.2rem solid #000;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .btn-b {
    width: 100%;
    padding: 0.3rem 0;
  }
</style>
